import { Component, OnInit } from '@angular/core';
import { TableData } from '@dxo/ng-swift-ui';
import { DropdownOption } from '@benefitsui/app/lib/common.types';
import { FormCellItemType, stateList } from './forms-page.types';
import { FormsClient, FormsFlag } from '@benefitsui/app/api/benefits-clients';
import { FormsService } from './forms.service';

@Component({
  selector: 'app-employeeforms-page',
  templateUrl: './employee-page.component.html',
  styleUrls: ['./employee-page.component.scss'],
  standalone: false
})
export class EmployeeFormsPageComponent implements OnInit {
  constructor(
    private formsClient: FormsClient,
    private formsService: FormsService
  ) {}

  selectState = 'All';
  employeeDataTable!: TableData;

  enrollmentDataTable!: TableData;
  eoiDataTable!: TableData;
  waiverDataTable!: TableData;
  conversionDataTable!: TableData;
  portabilityDataTable!: TableData;
  employeeBodyHeader = 'Employee forms';

  enrollmentBodyHeader = 'Enrollment';
  eoiBodyHeader = 'Evidence of insurability';
  waiverBodyHeader = 'Waiver';
  conversionBodyHeader = 'Conversion';
  portabilityBodyHeader = 'Portability';

  isLoading = true;
  statesDropdown: DropdownOption<string>[] = stateList;
  selectStateBodyHeader = "Select employee's resident state";
  showEmployee = false;
  hasEmployee = false;
  showEnrollment = false;
  hasEnrollment = false;
  showEOI = false;
  hasEOI = false;
  showWaiver = false;
  hasWaiver = false;
  showConversion = false;
  hasConversion = false;
  showPortability = false;
  hasPortability = false;

  ngOnInit(): void {
    this.fillData();
    this.setFalse();
  }

  onFilterChange(value: string) {
    this.selectState = value;
    this.fillData();
    if (value === 'All') {
      this.setFalse();
    } else {
      this.setTrue();
    }
  }

  setFalse(): void {
    this.showEmployee = false;
    this.hasEmployee = false;
    this.showEnrollment = false;
    this.hasEnrollment = false;
    this.showEOI = false;
    this.hasEOI = false;
    this.showWaiver = false;
    this.hasWaiver = false;
    this.showConversion = false;
    this.hasConversion = false;
    this.showPortability = false;
    this.hasPortability = false;
  }

  setTrue(): void {
    if (this.hasEmployee) {
      this.showEmployee = true;
    }
    if (this.hasEnrollment) {
      this.showEnrollment = true;
    }
    if (this.hasEOI) {
      this.showEOI = true;
    }
    if (this.hasWaiver) {
      this.showWaiver = true;
    }
    if (this.hasConversion) {
      this.showConversion = true;
    }
    if (this.hasPortability) {
      this.showPortability = true;
    }
  }

  fillData(): void {
    this.formsClient.allForms(this.selectState).subscribe((response) => {
      this.formsService.setFormsData(response.data?.employeeForms as FormCellItemType[], FormsFlag.EmployeeForm);
      const employeeFormsData = this.formsService.getFormsData(FormsFlag.EmployeeForm);
      if (employeeFormsData) {
        if (employeeFormsData.length > 0) {
          this.hasEmployee = true;
        }
        const enrollmentData = employeeFormsData.filter(
          (x) =>
            x.englishFormNumber.startsWith('LG-12011') ||
            x.englishFormNumber.startsWith('LG-12009') ||
            x.name.startsWith('Enrollment Form')
        );
        const eoiData = employeeFormsData.filter(
          (x) =>
            x.englishFormNumber.startsWith('LGC-2106') ||
            x.englishFormNumber.startsWith('LGC-8741') ||
            x.englishFormNumber.startsWith('LGC-2210') ||
            x.name.startsWith('Evidence of Insurability')
        );
        const waiverData = employeeFormsData.filter(
          (x) => x.englishFormNumber === 'LG-1' 
          || x.englishFormNumber === 'LG-1/NY' 
          || x.name.startsWith('PFL-Waiver')
        );
        const conversionData = employeeFormsData.filter((x) => x.conversion === true);
        const portabilityData = employeeFormsData.filter((x) => x.portability === true);
        this.enrollmentDataTable = this.formsService.transformData(enrollmentData);
        this.eoiDataTable = this.formsService.transformData(eoiData);
        this.waiverDataTable = this.formsService.transformData(waiverData);
        this.conversionDataTable = this.formsService.transformData(conversionData);
        this.portabilityDataTable = this.formsService.transformData(portabilityData);

        if (enrollmentData) {
          this.hasEnrollment = enrollmentData.length > 0;
        }
        if (eoiData) {
          this.hasEOI = eoiData.length > 0;
        }
        if (waiverData) {
          this.hasWaiver = waiverData.length > 0;
        }
        if (conversionData) {
          this.hasConversion = conversionData.length > 0;
        }
        if (portabilityData) {
          this.hasPortability = portabilityData.length > 0;
        }
      }
    });
    this.isLoading = false;
  }
}
